import type { Fallacy } from "./types";
import { createStory } from "./types";

export const appealToComplexity: Fallacy = {
    id: "appeal-to-complexity",
    name: "Appeal to Complexity",
    emoji: "🌀",
    category: "Jebakan Bahasa",
    description:
      "Menolak menjelaskan argumen dengan alasan **\"terlalu kompleks\"**, sehingga lawan bicara **berhenti bertanya**.",
    tldr: "\"Kamu gak bakal ngerti, ini rumit\" — cara malas buat kabur dari pertanyaan.",
    detail:
      "Appeal to Complexity terjadi ketika seseorang **menolak menjelaskan argumennya** dengan berlindung di balik kerumitan topik: \"Ini terlalu kompleks buat kamu pahami, jadi terima aja kesimpulan saya.\"\n\nIni gabungan dari **intimidasi intelektual dan kemalasan berargumen**. Pelakunya bisa jadi memang tidak paham topiknya sendiri, atau sengaja menghindari pertanyaan sulit.\n\nKenapa ini fallacy? Karena jika argumen valid, **seharusnya bisa dijelaskan lebih sederhana** — setidaknya intinya. Seperti kata Einstein: \"Kalau kamu tidak bisa menjelaskannya dengan sederhana, kamu belum cukup memahaminya.\"\n\nCara melawan: \"Coba jelaskan intinya. **Kalau memang benar, pasti bisa disederhanakan.**\"",
    story: createStory("Appeal to Complexity", "🌀", {
      hook: {
        title: "Kamu nanya pertanyaan yang wajar...",
        body: "Tapi dijawab: **\"Kamu gak bakal ngerti, ini rumit.\"** Terus kamu disuruh terima aja.",
      },
      convo: {
        claim: "Ini soal corporate finance. **Kalau saya jelasin kamu gak bakal ngerti.** Terima aja keputusannya!",
        response: "Kalau argumennya valid, **harusnya bisa dijelasin lebih sederhana.** Gak ngerti bukan alasan buat gak transparan.",
      },
      reveal: {
        body: "**Berlindung di balik kerumitan** buat kabur dari pertanyaan. Bisa jadi dia sendiri gak ngerti, atau males jelasin.",
      },
      insight: {
        title: "Aturan simpelnya?",
        body: "Kalau argumen beneran valid, **pasti bisa dijelasin lebih sederhana**. Yang gak bisa jelasin bisa jadi emang gak ngerti sendiri.",
      },
      engagement: {
        title: "Pernah dijawab \"kamu gak bakal ngerti\" waktu nanya hal wajar?",
        body: "Di kantor atau sama \"guru crypto\"? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["ad-hominem", "appeal-to-authority", "dunning-kruger"],
  };
